import { ArrowRightIcon } from '@axieinfinity/dango-icons'

import { useCaptureEvent } from '#/hooks'
import { useUserProfile } from '#/hooks/query'

import s from './header.module.scss'

export const Header = () => {
  const { data: profile } = useUserProfile()
  const captureEvent = useCaptureEvent()

  return (
    <header className={s.header} id="header">
      <div className={s.axie} />
      <div className={s.axs} />
      <div className={s.slp} />
      <div className={s.navigate}>
        <a href="/" className={s.back} onClick={() => captureEvent('Back to Mavis Hub')}>
          <ArrowRightIcon size={20} />
          <span>Back to Mavis Hub</span>
        </a>
        {profile && <div className={s.user}>
          <span className={s.greeting}>Howdy, </span>
          <span className={s.name} title={profile.name}>{profile.name}</span>
        </div>}
      </div>
      <div className={s.logo} />
      <div className={s.rocket} />
    </header>
  )
}
